import { render } from "./add-salary.vue?vue&type=template&id=4a84e736"
import script from "./add-salary.vue?vue&type=script&lang=js"
export * from "./add-salary.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__